import React from "react"
import { Card, Col, Container, Row } from "reactstrap"
import { T } from "../../traks"
import { site_name } from '../../Site';

export const PremiumInfo = () => {
    return (
        <Card className="mt-4 pt-3 pb-3 no-border-color border-radius-10">
            <Container>
            <Row className="mt-5">
            <Col sm="6" className="d-flex flex-column justify-content-center">
                    <Row>
                        <Col>
                            <h3 className="txt-40px fw_900"><T>More opportunities – more realism</T></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span><T>With Premium, you get the chance to create more realistic courses and challenges that ensure a realistic, engaging, and educational experience, filled with strategic opportunities for your participants.</T></span>
                        </Col>
                    </Row>
                </Col>
                <Col sm="6">
                    <div className="premium-image-square-wrapper">
                        <img
                        className="premium-info-img"
                        src="https://static.aktiedysten.dk/imgs/1-5-768x432.jpg"
                        alt="Open laptop displaying financial data, including charts and graphs"
                        />
                    </div>
                </Col>
            </Row>

            <Row className="mt-5 pt-5">
                <Col sm="6">
                    <div className="premium-image-square-wrapper">
                        <img className="premium-rounded-corners premium-info-img" width="100%" height="100%" src="https://static.aktiedysten.dk/gfx/diversification_05-08-25.jpg " alt="Students celebrating a school stock market competition win" />
                    </div>
                </Col>
                <Col sm="6" className="d-flex flex-column justify-content-center">
                    <Row>
                        <Col>
                            <h3 className="txt-40px fw_900"><T>Maintain Diversification and Avoid Day Trading</T></h3>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <span><T>Diversification is one of the most important strategies you can learn. It’s about not putting all your eggs in one basket – “Diversification is your salvation”! Premium helps you avoid day trading and ensures better diversification.</T></span>
                        </Col>
                    </Row>
                    <Row>
                        <ul className="premium-list">
                            <li><T>More asset classes and markets</T></li>
                            <li><T>Trading limits for participants</T></li>
                            <li><T>Risk-adjusted returns as competition parameters</T></li>
                            <li><T>Option to limit individual stocks</T></li>
                        </ul>
                    </Row>
                </Col>
            </Row>

            <Row className="mt-5 pt-5">
                <Col sm="6" className="d-flex flex-column justify-content-center">
                <Row>
                        <Col>
                            <h3 className="txt-40px fw_900"><T>From Guesswork to Meaningful Investing</T></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span><T>Premium gives you access to financial statements, company analyses, and risk data, so your participants’ decisions are based on more than just gut feelings.</T></span>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="pt-3">
                            <span><T>Think like a real investor - not based on guesswork.</T></span>
                        </Col>
                    </Row>
                </Col>
                <Col sm="6">
                    <div className="premium-image-square-wrapper">
                        <img
                            className="premium-info-img"
                            src="https://static.aktiedysten.dk/gfx/guesswork_05-08-25.jpg"
                            alt="Open laptop displaying a spreadsheet-like table with rows and columns of data.  The table shows various metrics, percentages, and possibly IDs.  A cup of cappuccino is visible on a table surface in the foreground"
                        />
                    </div>
                </Col>
            </Row>



            <Row className="mt-5 pt-5">
                <Col sm="6">
                    <div className="premium-image-square-wrapper">
                        <img
                            className="premium-rounded-corners premium-info-img"
                            width="100%"
                            height="100%"
                            src="https://static.aktiedysten.dk/gfx/control_05-08-25.jpg"
                            alt="A person looking at a laptop screen displaying a website with various company logos, including Spotify, CAT, Coca-Cola, Twitter, Tesla, and IBM"
                        />
                    </div>
                </Col>
                <Col sm="6" className="d-flex flex-column justify-content-center">
                    <Row>
                        <Col>
                            <h3 className="txt-40px fw_900"><T>Full Control Over Your Courses</T></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span><T>Manage participants and registrations with just a few clicks. Remove participants, close registrations – without starting over.</T></span>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="pt-3">
                            <span className="text-italic"><T>Pssst: With Premium, you can also add or deduct capital from participants. It’s a fun way to reward them – or the opposite – depending on how they complete the tasks you’ve set ;)</T></span>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row className="mt-5 pt-5">
            <Col sm="6" className="d-flex flex-column justify-content-center">
                    <Row>
                        <Col>
                            <h3 className="txt-40px fw_900"><T>Host BIG Competitions!</T></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span><T>Create large games with 100+ participants and bring together your entire school, workplace, or community.</T></span>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="pt-3">
                            <span><T>There are many good reasons to host large Stock Challenges. With Premium, you decide how many you want to invite to your game. Once you’ve chosen your number, you’ll also get the option to create games with more than 30 participants.</T></span>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="pt-3">
                            <span className="text-italic ad_90pct"><T>Note: {site_name} may only be used for commercial purposes with prior agreement with Stock Challenge.</T></span>
                        </Col>
                    </Row>
                </Col>
                <Col sm="6">
                    <div className="premium-image-square-wrapper">
                        <img
                            className="premium-rounded-corners premium-info-img"
                            width="100%"
                            height="100%"
                            src="https://static.aktiedysten.dk/imgs/IMG_7898-768x576.jpg"
                            alt="A person looking at a laptop screen displaying a website with various company logos, including Spotify, CAT, Coca-Cola, Twitter, Tesla, and IBM"
                        />
                    </div>
                </Col>
            </Row>
            </Container>
       </Card>
    )
}


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumInfo.js